import React from 'react'
import { Input, FormGroup, Label, InputGroup, InputGroupAddon, InputGroupText } from 'reactstrap'
import PropTypes from 'prop-types'
import isEmpty from '../utils/isEmpty'

export default function CustomInputGroup({
  onChange,
  name,
  label,
  value,
  type,
  placeholder,
  autoComplete,
  readOnly,
  invalid,
  errorMess,
  error,
  className,
  disabled,
  formClassName,
  style,
  min,
  max,
  prependAddon,
  rows,
}) {
  return (
    <FormGroup className={formClassName}>
      {label ? <Label>{label}</Label> : null}
      <InputGroup>
        {prependAddon && (
          <InputGroupAddon addonType='prepend'>
            <InputGroupText style={{ padding: '0 5px' }}>{prependAddon}</InputGroupText>
          </InputGroupAddon>
        )}
        <Input
          rows={rows}
          min={min}
          max={max}
          style={style}
          className={className}
          onChange={onChange}
          name={name}
          readOnly={readOnly}
          value={value}
          type={type}
          placeholder={placeholder}
          autoComplete={autoComplete}
          invalid={invalid || !isEmpty(error)}
          bsSize='sm'
          disabled={disabled}
        />
      </InputGroup>
      <small className='text-danger'>{errorMess || (error && error[name] && error[name].errorMessage)}</small>
    </FormGroup>
  )
}

CustomInputGroup.propTypes = {
  label: PropTypes.string,
  readOnly: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  type: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  invalid: PropTypes.bool,
  removeLabel: PropTypes.bool,
  autoComplete: PropTypes.string,
  errorMess: PropTypes.string,
  error: PropTypes.object,
  className: PropTypes.string,
}

CustomInputGroup.defaultProps = {
  readOnly: false,
}
